import { createReducer, on } from '@ngrx/store';

import * as MeasurementsActions from './measurements.actions';
import { Measurement, MeasurementsState, MeasurementSummary } from '../models/measurements.model';

export const initialState: MeasurementsState = {
  measurementOverview: null,
  measurement: null,
};

export const measurementsReducer = createReducer<MeasurementsState>(
  initialState,
  on(MeasurementsActions.loadMeasurementOverviewSuccess, (state, { measurementOverview }) => ({
    ...state,
    measurementOverview,
  })),
  on(MeasurementsActions.loadMeasurementSuccess, (state, { measurement }) => ({
    ...state,
    measurement,
  })),
  on(MeasurementsActions.initializeMeasurementSuccess, (state, { measurement }) => ({
    ...state,
    measurement,
  })),
  on(MeasurementsActions.copyMeasurementSuccess, (state, { measurement }) => ({
    ...state,
    measurement,
  })),
  on(MeasurementsActions.calculateMeasurementSuccess, (state, { measurement }) => ({
    ...state,
    measurement,
  })),
  on(MeasurementsActions.clearMeasurementOverview, (state) => ({
    ...state,
    measurementOverview: null as MeasurementSummary[],
  })),
  on(MeasurementsActions.clearMeasurement, (state) => ({
    ...state,
    measurement: null as Measurement,
  })),
);
